import React, { useState, useEffect } from 'react'

interface BannerCarouselProps {
  images: string[]
}

const BannerCarousel: React.FC<BannerCarouselProps> = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [bannerHeight, setBannerHeight] = useState(getBannerHeight())

  const hasMultipleImages = images.length > 1

  function getBannerHeight() {
    const zoom = window.devicePixelRatio
    const vh = window.innerHeight * 0.5 // 60% of viewport height
    if (zoom >= 1.25) return vh * 0.9
    if (zoom >= 1.1) return vh * 1.05
    return vh
  }

  useEffect(() => {
    if (!hasMultipleImages) return

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      )
    }, 5000)

    return () => clearInterval(interval)
  }, [images, hasMultipleImages])

  useEffect(() => {
    const handleResize = () => {
      setBannerHeight(getBannerHeight())
    }

    window.addEventListener('resize', handleResize)
    window.addEventListener('orientationchange', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('orientationchange', handleResize)
    }
  }, [])

  return (
    <div
      className="relative w-full overflow-hidden"
      style={{ height: `${bannerHeight}px` }}
    >
      {images.map((image, index) => (
        <img
          key={index}
          src={image}
          alt={`Banner ${index + 1}`}
          className={`absolute inset-0 w-full h-full object-fill transition-opacity duration-700 ${
            index === currentIndex ? 'opacity-100' : 'opacity-0'
          }`}
        />
      ))}

      {hasMultipleImages && (
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-3 h-3 rounded-full ${
                index === currentIndex ? 'bg-white' : 'bg-gray-400'
              }`}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default BannerCarousel
